/**
* Cart JS
* -----------------------------------------------------------------------------
*
* All the JS for the Cart component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import store from '../../resources/js/app';
// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'cart',
    selector: function() {
      return '.' + this.className;
    },
    loadingSection: $( '#sidebar-cart-loading' ),
    contentsSections: $( '#sidebar-cart-contents' ),
    emptySection: $( '#sidebar-cart-empty' ),
    cartItems: $( '#sidebar-cart-items' ),
    cartSubtotal: $( '#sidebar-cart-subtotal' ),
    cartFees: $( '#sidebar-cart-fees' ),
    cartTotalOutstanding: $( '#sidebar-cart-total-outstanding' ),
    cartTotal: $( '#sidebar-cart-total' ),
    cartDiscount: $( '#sidebar-cart-discount' ),
    cartGiftCard: $( '#sidebar-cart-gift-card' ),
    cartMerchandise: $( '#sidebar-cart-merchandise' ),
    checkoutLoadingSection: $( '#checkout-cart-loading' ),
    checkoutContentsSections: $( '#checkout-cart-contents' ),
    checkoutEmptySection: $( '#checkout-cart-empty' ),
    checkoutCartItems: $( '#checkout-cart-items' ),
    checkoutCartSubtotal: $( '#checkout-cart-subtotal' ),
    checkoutCartFees: $( '#checkout-cart-fees' ),
    checkoutCartTotalOutstanding: $( '#checkout-cart-total-outstanding' ),
    checkoutCartTotal: $( '#checkout-cart-total' ),
    checkoutCartDiscount: $( '#checkout-cart-discount' ),
    checkoutCartGiftCard: $( '#checkout-cart-gift-card' ),
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const _this = this;
      _this.loadCart();
      // console.log( store.state.isLoggedIn );

      $( document ).on( 'click', '.cart__remove-item', function( e ) {
        const tickets = $( e.target ).data( 'tickets' );
        _this.removeItem( tickets );
      } );

      $( document ).on( 'click', '#cart-buy-tickets-button', function( e ) {
        $( '.sidebar-cart-button' ).first().click();
        $( '.buy-tickets-button' ).first().click();
      } );

      $( document ).on( 'click', '#cart-clear-cart-button', function( e ) {
        _this.clearCart();
      } );

      $( '.cart__promo-code-button' ).click( function() {
        const code = $( '#cart-promo-code' ).val();
        _this.applyCode( code );
      } );
    },
    finalize: function() {
    },
    loadCart: function() {
      const _this = this;

      _this.cartItems.html( '' );

      if ( _this.checkoutCartItems.length ) {
        _this.checkoutCartItems.html( '' );
      }

      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'load_cart_contents',
            params: {
              is_running: true,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              if ( ! data.response ) {
                _this.loadingSection.addClass( 'hidden' );
                _this.contentsSections.addClass( 'hidden' );
                _this.emptySection.removeClass( 'hidden' );
                _this.checkoutLoadingSection.addClass( 'hidden' );
                _this.checkoutContentsSections.addClass( 'hidden' );
                _this.checkoutEmptySection.removeClass( 'hidden' );
                $( '#sidebar-cart-count' ).text( '0' );
                $( '#checkout-cart-count' ).text( '0' );
                $( '.sidebar-cart-button .cart-items' ).text( '0' );
                $( '.sidebar-cart-button .cart-items' ).addClass( 'hidden' );
                localStorage.removeItem( 'giftCardApplied' );
                localStorage.removeItem( 'giftCardValue' );
                localStorage.removeItem( 'giftCard' );
                localStorage.removeItem( 'totalOutstanding' );
              } else {
                _this.loadingSection.addClass( 'hidden' );
                _this.contentsSections.removeClass( 'hidden' );
                _this.emptySection.addClass( 'hidden' );
                _this.checkoutLoadingSection.addClass( 'hidden' );
                _this.checkoutContentsSections.removeClass( 'hidden' );
                _this.checkoutEmptySection.addClass( 'hidden' );
                $( '#sidebar-cart-count' ).text( data.response.cart_count );
                $( '#checkout-cart-count' ).text( data.response.cart_count );
                $( '.sidebar-cart-button .cart-items' ).text( data.response.cart_count );

                if ( data.response.cart_count > 0 ) {
                  $( '.sidebar-cart-button .cart-items' ).removeClass( 'hidden' );
                } else {
                  $( '.sidebar-cart-button .cart-items' ).addClass( 'hidden' );
                }

                let cartHtml = ``;
                let checkoutHtml = ``;

                $.each( data.response.items, function( index, item ) {
                  let tickets = [];
                  $.each( item.tickets, function( index, ticket ) {
                    tickets.push( ticket['id'] );
                  } );
                  tickets = JSON.stringify( tickets );

                  // html += `
                  //         <div class="cart__number-input-group">
                  //           <button type="button" name="button">
                  //             <svg class="icon icon-minus pointer-events-none"><use xlink:href="#icon-minus"></use></svg>
                  //           </button>
                  //           <input type="number" value="${item.tickets.length}">
                  //           <button type="button" name="button">
                  //             <svg class="icon icon-plus pointer-events-none"><use xlink:href="#icon-plus"></use></svg>
                  //           </button>
                  //         </div>
                  // `;
                  cartHtml += `
                  <div class="flex items-stretch mb-8">
                    <div class="relative flex-initial w-24 h-24 flex-shrink-0 bg-gray mr-6">
                    ${item.image}
                    </div>
                    <div class="flex-initial flex-grow flex flex-col">
                      <div class="flex-initial w-full flex">
                        <div class="flex-initial mr-6">
                          <div class="block text-sm font-medium text-gray-dark-charcoal leading-snug">${item.name}: ${item.type}</div>
                        </div>
                        <div class="flex-initial ml-auto">
                          <button class="cart__remove-item" type="button" data-tickets='${tickets}'>
                            <svg class="icon icon-trash-can pointer-events-none"><use xlink:href="#icon-trash-can"></use></svg>
                          </button>
                        </div>
                      </div>
                      <div class="flex-initial flex mt-auto items-end">
                        <div class="flex-initial">
                          <span class="text-sm font-medium">Quantity: ${item.tickets.length}</span>
                        </div>
                        <div class="flex-initial ml-auto">
                          <span class="text-gray-charcoal leading-snug">
                            $${item.ticket_total_formatted}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  `;

                  if ( _this.checkoutCartItems.length ) {
                    checkoutHtml += `
                    <div class="flex items-stretch mb-8 px-4 py-6 bg-white">
                      <div class="relative flex-initial w-24 h-24 flex-shrink-0 bg-gray mr-6">
                      ${item.image}
                      </div>
                      <div class="flex-initial flex-grow flex flex-col">
                        <div class="flex-initial w-full flex">
                          <div class="flex-initial mr-6">
                            <div class="block text-sm font-medium text-gray-dark-charcoal leading-snug">${item.name}: ${item.type}</div>
                          </div>
                          <div class="flex-initial ml-auto">
                            <button class="cart__remove-item" type="button" data-tickets='${tickets}'>
                              <svg class="icon icon-trash-can pointer-events-none"><use xlink:href="#icon-trash-can"></use></svg>
                            </button>
                          </div>
                        </div>
                        <div class="flex-initial flex mt-auto items-end">
                          <div class="flex-initial">
                            <span class="text-sm font-medium">Quantity: ${item.tickets.length}</span>
                          </div>
                          <div class="flex-initial ml-auto">
                            <span class="text-gray-charcoal leading-snug">
                              $${item.ticket_total_formatted}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    `;
                  }
                } );

                const giftCardValue = localStorage.getItem( 'giftCardValue' );
                let giftCardApplied = giftCardValue;
                let totalOutstanding = parseFloat( data.response.total_outstanding ).toFixed( 2 );
                if ( giftCardValue ) {
                  if ( parseFloat( giftCardValue ) > parseFloat( totalOutstanding ) ) {
                    giftCardApplied = parseFloat( totalOutstanding );
                  }
                  totalOutstanding = parseFloat( parseFloat( data.response.total_outstanding ) - parseFloat( giftCardValue ) ).toFixed( 2 );
                }
                if ( totalOutstanding < 0 ) {
                  totalOutstanding = '0.00';
                }
                localStorage.setItem( 'totalOutstanding', totalOutstanding );
                localStorage.setItem( 'giftCardApplied', giftCardApplied );

                _this.cartItems.html( cartHtml );
                _this.cartSubtotal.html( '$' + data.response.subtotal );
                _this.cartFees.html( '$' + data.response.fees );
                _this.cartTotalOutstanding.html( '$' + totalOutstanding );

                // console.log( Math.abs( parseFloat( data.response.discount ) ) );
                if ( Math.abs( parseFloat( data.response.discount ) ) > 0 ) {
                  _this.cartTotal.html( '$' + data.response.total );
                  _this.cartDiscount.html( '-$' + Math.abs( data.response.discount ).toFixed( 2 ) );
                  $( '#sidebar-cart-discount-totals' ).removeClass( 'hidden' );
                } else {
                  $( '#sidebar-cart-discount-totals' ).addClass( 'hidden' );
                }

                if ( Math.abs( parseFloat( giftCardApplied ) ) > 0 ) {
                  _this.cartGiftCard.html( '-$' + Math.abs( giftCardApplied ).toFixed( 2 ) );
                  $( '#sidebar-cart-gift-card-section' ).removeClass( 'hidden' );
                } else if ( Math.abs( parseFloat( data.response.gift_card_payed ) ) > 0 ) {
                  _this.cartGiftCard.html( '-$' + Math.abs( data.response.gift_card_payed ).toFixed( 2 ) );
                  $( '#sidebar-cart-gift-card-section' ).removeClass( 'hidden' );
                } else {
                  $( '#sidebar-cart-gift-card-section' ).addClass( 'hidden' );
                }

                if ( _this.checkoutCartItems.length ) {
                  _this.checkoutCartItems.html( checkoutHtml );
                  _this.checkoutCartSubtotal.html( '$' + data.response.subtotal );
                  _this.checkoutCartFees.html( '$' + data.response.fees );
                  _this.checkoutCartTotalOutstanding.html( '$' + totalOutstanding );

                  if ( Math.abs( parseFloat( data.response.discount ) ) > 0 ) {
                    _this.checkoutCartTotal.html( '$' + data.response.total );
                    _this.checkoutCartDiscount.html( '-$' + Math.abs( data.response.discount ).toFixed( 2 ) );
                    $( '#checkout-cart-discount-totals' ).removeClass( 'hidden' );
                  } else {
                    $( '#checkout-cart-discount-totals' ).addClass( 'hidden' );
                  }

                  if ( Math.abs( parseFloat( giftCardApplied ) ) > 0 ) {
                    _this.checkoutCartGiftCard.html( '-$' + Math.abs( giftCardApplied ).toFixed( 2 ) );
                    $( '#checkout-cart-gift-card-section' ).removeClass( 'hidden' );
                  } else if ( Math.abs( parseFloat( data.response.gift_card_payed ) ) > 0 ) {
                    _this.checkoutCartGiftCard.html( '-$' + Math.abs( data.response.gift_card_payed ).toFixed( 2 ) );
                    $( '#checkout-cart-gift-card-section' ).removeClass( 'hidden' );
                  } else {
                    $( '#checkout-cart-gift-card-section' ).addClass( 'hidden' );
                  }
                }

                if ( data.response.merchandise ) {
                  let merchandiseHtml = ``;

                  $.each( data.response.merchandise, function( index, merchandise ) {
                    merchandiseHtml += `
                    <div class="flex items-stretch mb-8 bg-white py-5 px-3">
                      <div class="flex-initial w-24 h-24 flex-shrink-0 bg-gray mr-6 relative">
                        ${merchandise.image}
                      </div>
                      <div class="flex-initial flex-grow flex flex-col">
                        <div class="flex-initial w-full">
                          <div class="block text-sm font-medium text-gray-dark-charcoal leading-snug">${merchandise.name}</div>
                        </div>
                        <div class="flex-initial flex mt-auto items-end">
                          <div class="flex-initial ml-auto">
                            <button data-id="${index}" title="Buy ${merchandise.name}" class="buy-merchandise-trigger cart__add-button">View</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    `;
                  } );

                  _this.cartMerchandise.html( merchandiseHtml );
                  $( '.sidebar-cart__merchandise' ).removeClass( 'hidden' );
                  // <button data-id="1740" title="Buy UNION PACIFIC 4014 (BIG BOY) POSTER" class="buy-merchandise-trigger btn-white">Buy Merch</button>
                }
              }
            }
          }
      );
    },
    removeItem: function( tickets ) {
      const _this = this;
      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'remove_tickets',
            params: {
              tickets: tickets,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              _this.loadCart();
            }
          }
      );
    },
    applyCode: function( code ) {
      const _this = this;
      $( '.cart__promo-code-error' ).addClass( 'hidden' );
      $( '.cart__promo-code-success' ).addClass( 'hidden' );
      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'apply_promo_code',
            params: {
              code: code,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              if ( data.response._status === 'error' ) {
                if ( data.response._data[0]._description ) {
                  $( '.cart__promo-code-error' ).text( data.response._data[0]._description );
                } else {
                  $( '.cart__promo-code-error' ).text( 'Invalid code.' );
                }
                $( '.cart__promo-code-error' ).removeClass( 'hidden' );
              } else {
                $( '.cart__promo-code-success' ).removeClass( 'hidden' );
                $( '#cart-promo-code' ).val( '' );
                _this.loadCart();
              }
            }
          }
      );
    },
    clearCart: function() {
      const _this = this;
      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'clear_cart',
            params: {
              running: true,
            },
          },
          function( data, textStatus, xhr ) {
            data = $.parseJSON( data );
            if ( data.status === 'success' ) {
              _this.loadCart();
            }
          }
      );
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cart', COMPONENT );
} )( app );
